/**
 * First-touch attribution claim — fired once after a successful REGISTRATION
 * in the embed (email/password register or Google sign-up upgrading the
 * guest). The server keeps at most one claim per user forever (first touch
 * wins), so re-fires and races are harmless no-ops. Plain sign-ins of
 * existing accounts must NOT claim: that user's first touch predates this
 * surface.
 */
import { httpClient } from '../client';
import logger from '../utils/logger';

export function claimFirstTouch(
  campaignCode: string | null | undefined,
  instanceId: string | null | undefined,
): void {
  if (!campaignCode) return;
  // Fire-and-forget: attribution must never block or break the auth flow.
  httpClient
    .post('/attribution/v1/claim', {
      campaign_code: campaignCode,
      touch_type: 'embed_registration',
      source_context: {
        surface: 'embed',
        ...(instanceId ? { instance_id: instanceId } : {}),
      },
    })
    .catch(err => logger.warn('[attribution] claim failed', err));
}
